import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import { MuiThemeProvider } from '@material-ui/core/styles'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { baseTheme, darkTheme } from 'styles'

export class InfoDialog extends Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func
  }

  static defaultProps = {
    theme: 'light',
    classes: {}
  }

  handleRequestClose = () => {
    (this.props.onClose || this.props.onCancel)()
  }

  render() {
    return (
      <div>
        <MuiThemeProvider theme={this.props.theme === 'light' ? baseTheme : darkTheme}>
          <Dialog open={!!this.props.open}>
            {this.props.title &&
              <DialogTitle>
                {this.props.title}
              </DialogTitle>
            }
            <DialogContent className={this.props.classes.content}>
              { this.props.children }
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleRequestClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </MuiThemeProvider>
      </div>
    );
  }
}